var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1,30c-2.2-6.6-7.4-11.5-15-14.1c-12.6-4.5-30.6-2.1-42.7,5.6c-7,4.5-11.4,10.8-12.7,18.2c-1.2,6.6,0.4,12.7,2.2,16.5  c-0.8,0.5-1.4,1.1-2,1.8c-1.7,2-2.3,4.3-1.8,6.8c0.7,3.8,4.4,6.5,9.8,7.1c0.9,0.1,1.7,0.2,2.6,0.2c1.6,0,3.3-0.2,4.8-0.6  c1.6,2.9,1.4,5.5,0.8,7.2c-0.7,2.3-2.3,4.2-4.1,5l1.8,4.2c3-1.3,5.5-4.2,6.6-7.8c1.1-3.5,0.7-7.1-1-10.4c1-0.7,1.8-1.6,2.3-2.6  c0.4-0.9,0.7-1.7,0.8-2.6c16.1,1.8,34.7-4.3,43.3-14.5C87,43.9,88.4,37.1,86.1,30z M24.4,67.5c-2.6-0.3-5.5-1.4-6-3.5  c-0.2-1.1,0.1-2.1,0.8-3c0.3-0.3,0.6-0.6,1-0.9c1.7,2,3.5,3.6,5.2,5.1c0.9,0.8,1.7,1.5,2.5,2.3C26.9,67.6,25.6,67.6,24.4,67.5z   M33.7,65.1c-0.1,0.3-0.5,0.6-0.8,0.9c-1.4-1.6-2.8-2.9-4.3-4.2c-1.3-1.1-2.5-2.3-3.8-3.6c1-0.2,2-0.3,3.1-0.3  c2.7,0.1,4.8,1.1,5.8,2.7C34.3,62,34.4,63.6,33.7,65.1z M78.5,47c-7.8,9.2-25.7,14.8-40.3,12.8c-0.2-0.5-0.4-1-0.7-1.5  c-1.8-3-5.3-4.8-9.5-4.9c-2.1-0.1-4.2,0.3-6,0.9c-1.5-3.2-2.7-8.4-1.8-13.8c1.1-6.2,4.7-11.3,10.7-15.1c10.9-6.9,27.6-9.1,38.8-5.2  c4.3,1.5,9.9,4.7,12.2,11.3C83.6,37,82.5,42.2,78.5,47z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLasso);
export default __webpack_public_path__ + "static/media/lasso.01c2011c9f9f568a4d603bb875501081.svg";
export { ForwardRef as ReactComponent };